import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../config/authConfig";
import "../styles/UnAuthApp.css";

const UnAuthenticatedApp = () => {
  function handleLogin(instance) {
    instance.loginPopup(loginRequest).catch((e) => {
      console.error(e);
    });
  }
  const { instance } = useMsal();

  return (
    <div className="unauth-container">
      <h1>Lunar Design Log In</h1>
      <button className="login-button" onClick={() => handleLogin(instance)}>
        Sign in
      </button>
    </div>
  );
};

export default UnAuthenticatedApp;
